/* eslint-disable import/order */
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncDirectoryNav } from '@jira/navigation-apps__horizontal-nav-jsm-directory/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskOrganizationsRoute } from '@jira/router-routes__servicedesk-organizations-routes/src/servicedeskOrganizationsRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ServiceDeskOrganizations, LazyServicedeskOrganizations } from './ui/index.tsx';

export const servicedeskOrganizationsRouteEntry: Route = createEntry(
	servicedeskOrganizationsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			csmCustomerContextTenantMigratedStatusResource,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskOrganizations,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizations],
		perfMetricKey: 'jsm-organizations-component-load',

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncDirectoryNav,
		},

		meta: {
			reporting: {
				id: APP_NAMES.ORGANIZATIONS,
				packageName: toPackageName(APP_NAMES.ORGANIZATIONS),
				teamName: 'boysenberry',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
